/**
 *  Filename ....: approverequest.component.ts
 *  Created by ..: ianday
 *  on Date .....: 10/23/23
 **/
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DwUtils } from "../../../../components/utils/dw-utils";
import { ServiceRequest } from "../../../../models/service.request";
import { ServiceRequestsService } from "../../../../services/service-requests.service";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { MessageDefinitionService } from "../../../../services/messages.service";
import { NewMessageHelper } from "../../drawer/mailmessages/newmessage/newmessage-helper";
import { Settings } from 'src/app/services/settings';
import { AgencyResponse } from "../../../../models/agency-response";
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatTableDataSource } from "@angular/material/table";
import { CollaborateRequestComponent } from "../collaborate-request/collaborate-request.component";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { GlobalService } from 'src/app/services/global.service';
import { RecloseDialogComponent } from 'src/app/components/reclose-dialog/reclose-dialog.component';
import { CasesService } from 'src/app/services/cases.service';
import { ServiceRequestMembersMap } from 'src/app/models/service-request-members-map';

class DataRecord {
	id: string;
	description: string;

	constructor(id: string, description: string) {
		this.id = id;
		this.description = description;
	}
}
@Component({
	selector: 'app-approverequest',
	templateUrl: './approverequest.component.html',
	styleUrls: ['./approverequest.component.css']
})

export class ApproveRequestComponent implements OnInit {

	public strErr: string | null = '';
	public enableSubmit: boolean | null = false;
	public disabledFlag: boolean | null = false;

	public localId: number;
	/*** structures ***/
	public _serviceRequest: ServiceRequest;

	public givingOptionsList: Array<DataRecord>;
	public closeRequest: boolean | null = false;

	/* static data fields */

	public caseNumber: string | null = '';
	public fullName: string | null = '';
	public serviceRequestType: string | null = '';

	/** calc amounts **/
	public requested: number = 0;
	public alreadyProvided: number = 0;
	public remaining: number = 0;

	public plannedCommitted: string | null = 'Committed';
	public approveAmount: number | null = 0;
	public startDate: string;
	public endDate: string;
	public unitOfMeasure: string | null = '';

	public agencyResponses: any;
	public result: boolean;

	public visibleCollaborate: boolean = false;
	public editSelfCollaborateResponses: boolean = false;
	public editOtherCollaborateResponses: boolean = false;
	public deleteAnyCollaborateResponses: boolean = false;
	public deleteSelfCollaborateResponses: boolean = false;

	public viewOtherCollaborateResponsesSecondary: boolean = false;
	public visibleAdd: boolean = false;
	public primaryAgencyFlag: boolean = false;
	public myAgencyId: number;

	public dataSource: MatTableDataSource<AgencyResponse>;
	public displayedColumns: any = ['id', 'agencyName', 'operation', 'plannedCommitted', 'amount', 'unitOfMeasure', 'responseDate', 'delete'];
	public selectedRecord: AgencyResponse;
	public arShadow: any;
	public Idx = -1;
	public hasAdmin: boolean = false;
	public addCollaborationDlg: boolean = false;
	public busyCursor: boolean = false;
	public plannedCommittedToolTipText: string;

	visibleFinalize = false;

	displayRecloseDlg = false;

	private pendingStatusSnapshot: { requestStatusId?: any; recordStatus?: any; statusReasonId?: any } = null;

	public msgHelper: NewMessageHelper;
	requestemebrsMappins: ServiceRequestMembersMap[];

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();
	@ViewChild('collaborateReq', { static: true }) collaborateReq: CollaborateRequestComponent;
	@ViewChild('reclosedlg', { static: true }) reclosedlg: RecloseDialogComponent;

	@Input() set serviceRequest(value: ServiceRequest) {
		if (value === undefined) {
			return;
		}

		this._serviceRequest = value;
		this.unitOfMeasure = value.unitOfMeasure;
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this._serviceRequest.agencyId);
		this.myAgencyId = Settings.getInstance().loggedInUser.agencyId;
		
			
			
		if(this.primaryAgencyFlag ===true){
			
			this.visibleAdd = true;
			this.viewOtherCollaborateResponsesSecondary = true;
			this.editSelfCollaborateResponses = true;
			this.visibleCollaborate =Settings.getInstance().hasPrivilege('REQUEST_COLLABORATION', 'SHOW');
			this.editOtherCollaborateResponses = Settings.getInstance().hasPrivilege('PRIMARY_AGENCY_OVERRIDE_OTHER_RESPONSES', 'EXECUTE');
			this.deleteAnyCollaborateResponses = Settings.getInstance().hasPrivilege('PRIMARY_AGENCY_DELETE_ANY_RESPONSE', 'EXECUTE');;
		} else{
			this.visibleCollaborate = false;
			this.editOtherCollaborateResponses = false;
			this.deleteAnyCollaborateResponses = false;
			this.editSelfCollaborateResponses = Settings.getInstance().hasPrivilege('COLLABORATED_AGENCY_OWN_RESPONSES', 'WRITE');
			this.viewOtherCollaborateResponsesSecondary = Settings.getInstance().hasPrivilege('COLLABORATED_AGENCY_VIEW_OTHER_RESPONSES', 'SHOW');
		}

		
		this.visibleFinalize = 
			this.primaryAgencyFlag &&
			Settings.getInstance().hasPrivilege('REQUEST_DETAIL_APPROVE_FINALIZE', 'SHOW');

		this.startDate = DwUtils.formatDateFromString(value.startDate);
		this.endDate = DwUtils.formatDateFromString(value.endDate);

		this.setUpListOptions();

	}
	public get serviceRequest(): ServiceRequest {
		return this._serviceRequest;
	}
	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		this.strErr = '';
	}
	constructor(private serviceRequestsService: ServiceRequestsService,
		private messageService: MessageDefinitionService,
		private casesService: CasesService,
		public serviceDefsService: ServiceDefService,
		private txService: TransactionHistoryService,
		private dialog: MatDialog,
		public globalService: GlobalService) {
		this.givingOptionsList = new Array();
	}

	public setUpListOptions(): void {
		this.givingOptionsList = new Array();

		this.givingOptionsList.push(new DataRecord('Committed', 'Committed'));
		this.givingOptionsList.push(new DataRecord('Planned', 'Planned'));

		if (this.primaryAgencyFlag === false) {
			this.givingOptionsList.push(new DataRecord('Denied', 'Denied'));
		}
		this.plannedCommittedToolTipText = 'Planned - Intention to provide the stated amount (not committed).\n\nCommitted - Firm commitment to provide the stated amount.';

	}
	ngOnInit() {

	}
	public onShowHandler(refreshOnlyFlag = false): void {

		this.alreadyProvided = 0;
		this.localId = -1;
		this.strErr = '';

		if (!refreshOnlyFlag) {
			this.approveAmount = 0;
		}

		this.remaining = 0;
		this.queryRecords();
	}
	public queryRecords(): void {

		if (this.serviceRequest === undefined)
			return;

		this.agencyResponses = [];
		this.arShadow = [];
		this.serviceRequestsService.getAgencyResponsesForServiceId(this.serviceRequest.id).subscribe(
			(result) => {
				this.alreadyProvided = 0;
				for (const rec of result) {
					rec['operation'] = '';
					rec['agencyName'] = Settings.getInstance().getAgencyName(rec.agencyId);
					this.alreadyProvided += Number(rec.amountProvided);
					
					// Check if the particular record is of another agency
					if (rec.agencyId !== this.myAgencyId) {
						// It's another agency - check the flag and act accordingly
						if (this.viewOtherCollaborateResponsesSecondary) {
							this.agencyResponses.push(rec);
						}
					} else {
						// Self response - just push it to array
						this.agencyResponses.push(rec);
					}
					
					this.arShadow.push(rec);
				}
				this.dataSource = new MatTableDataSource(this.agencyResponses);
				this.setValues(true);
				this.loadMembers();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching agency response records')
			});
	}
	public loadMembers() {
		/** For clerically reopened requests the live mappings table is empty —
		 *  use the history table instead and treat selected=1 rows as "mapped". **/
		if (this.serviceRequest.clericalOpen === 1) {
			this.casesService.getMemberHistory(this.serviceRequest.id).subscribe(
				(historyRecords: any[]) => {
					this.requestemebrsMappins = historyRecords.filter(h => h.selected === 1) as any[];
				},
				() => {
					Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
				}
			);
		} else {
			this.casesService.getServiceRequestMemberMappingsByServiceRequestId(this.serviceRequest.id).subscribe(
				(mapped: any[]) => {
					this.requestemebrsMappins = mapped;
				},
				() => {
					Settings.getInstance().handleError('Error: unable to retrieve member mappings from the server');
				}
			);
		}
	}
	public setValues(refreshOnlyFlag = false): void {

		if (!refreshOnlyFlag) {
			this.approveAmount = 0;
		}
		this.requested = this.serviceRequest.amountRequested;
		this.caseNumber = this.serviceRequest.caseNumber;
		this.fullName = this.serviceRequest.caseName;
		this.serviceRequestType = this.serviceRequest.serviceRequestDesc;

		this.updateTotal();
		this.doSetFocus();
	}
	public doSetFocus(): void {
		if (this.primaryAgencyFlag === true) {
			DwUtils.highlightFocus('startDateId');
		}
		// Secondary agencies: let user choose a row manually
	}
	public doFocusRow(): void {
		try {
			/** get's the top most row in the array **/
			const focusRow = this.dataSource.data.find(s => s.agencyId === this.myAgencyId);
			if (focusRow !== undefined) {
				this.onRowClicked(focusRow);
			}
		}
		catch (error) { /** nothing **/ }
	}
	public tableKeyDown(event: any): void {

		const len: number = this.dataSource.filteredData.length;
		this.strErr = '';

		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				DwUtils.setFocus('contributionsTableId');
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				DwUtils.setFocus('contributionsTableId');
			}
		}
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public validateAmountEntered(val: any): boolean {

		if (val.toString() === '') {
			this.strErr = 'Error: Cannot accept a blank value - please specify a non-zero amount';
			DwUtils.highlightFocus('idAmount');
			return false;
		}
		if (Number(val) < 0) {
			this.strErr = 'Error: Cannot accept a negative number';
			DwUtils.highlightFocus('idAmount');
			return false;
		}
		return true;
	}
	public doStatusChange(id: number, element: AgencyResponse): void {

		this.updateShadow(id, 'plannedCommitted', element.plannedCommitted);

		if (element.plannedCommitted === 'Denied') {
			element.amountProvided = 0.00;
			this.doAmountChange(null, element);
		}
	}
	public doAmountChange(event: any, element: AgencyResponse): void {

		if (this.validateAmountEntered(element.amountProvided) == false) {
			return;
		}

		this.updateShadow(element.id, 'amountProvided', element.amountProvided);
		this.updateTotal();
	}
	public updateTotal(): void {
		this.alreadyProvided = 0;
		for (const rec of this.agencyResponses) {
			this.alreadyProvided += Number(rec.amountProvided);
		}
		this.remaining = this.requested - this.alreadyProvided;
		if (this.remaining < 0) {
			this.remaining = 0;
		}

		//if (this.approveAmount <= 0 && this.alreadyProvided<=0) {
		//	this.enableSubmit = false;
		//} else{
		this.enableSubmit = true;
		//}

	}
	public lblDecimal(inp: number): string {

		let retVal = '';
		if (inp === null) {
			return retVal;
		}

		retVal = (Math.round(inp * 100) / 100).toFixed(2);

		return retVal;
	}
	public deleteResponse(element) {
		const message = 'Remove this contribution?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {

				/** is the element created yet? **/
				if (element.id < 0) {
					let idx = this.arShadow.findIndex(s => s.id === element.id)
					if (idx > -1) {
						/** remove the unsaved (session-added) row from the pending-changes
						 * shadow so it is not re-created on Save. splice(idx, 1) removes the
						 * one record; the previous splice(idx, 0) removed nothing. **/
						this.arShadow.splice(idx, 1);
					}
				}
				else { /** the record exists with a positive id value **/
					this.updateShadow(element.id, 'operation', 'D')
				}

				this.agencyResponses = this.agencyResponses.filter(rec => rec.id !== element.id);
				this.dataSource = new MatTableDataSource(this.agencyResponses);
				this.updateTotal();

				/** update the service Request with the new amount provided **/
				this.serviceRequest.totalAmountProvided = this.alreadyProvided;
				//this.serviceRequest.plannedCommitted = this.setCollaborationFlag();
			}
		});
	}
	public updateShadow(id: number, element: string, value: any) {

		let idx = this.arShadow.findIndex(s => s.id === id)

		if (idx < 0) {
			console.log('cannot locate shadow record: ' + id.toString())
			return;
		}

		/** set the value **/
		this.arShadow[idx][element] = value;

		if (this.arShadow[idx].id > 0) {
			if (this.arShadow[idx].hasOwnProperty('operation') === false) {
				this.arShadow[idx]['operation'] = 'U';
			} else if (this.arShadow[idx]['operation'] === '') {
				this.arShadow[idx]['operation'] = 'U';
			}
		}
	}
	public doAddNewContribution(): void {

		if (this.agencyResponses.length > 0) {
			if ((Number(this.agencyResponses[0].amountProvided) === 0) && (this.agencyResponses[0].agencyId === this.myAgencyId)) {
				this.strErr = 'Error: Contribution record already exists with a zero value';
				this.doFocusRow();
				return;
			}
			if (this.validateAmountEntered(this.agencyResponses[0].amountProvided) == false) {
				return;
			}
		}

		/*** create the entry in the DB with a zero value ***/
		this.selectedRecord = new AgencyResponse().setNewAgencyResponseRecord(
			this.serviceRequest.id, this.myAgencyId, this.serviceRequest.unitOfMeasure);

		this.selectedRecord.id = this.localId--;
		this.selectedRecord.operation = 'A';
		this.agencyResponses.unshift(this.selectedRecord);
		this.arShadow.unshift(this.selectedRecord);

		this.dataSource = new MatTableDataSource(this.agencyResponses);
		this.onRowClicked(this.selectedRecord);

	}
	public doCollaborate(): void {

		const agency = Settings.getInstance().agencyList.find(s => s.id === this._serviceRequest.agencyId);
		this.collaborateReq.doInitialize(agency, this.agencyResponses);

		this.addCollaborationDlg = true;
	}
	public doCollaborateSubmitted(event: any): void {

		this.addCollaborationDlg = false;

		if (event.length > 0) {

			for (let i = 0; i < event.length; i++) {
				event[i].id = this.localId--;
				event[i]['operation'] = 'A';
				this.agencyResponses.push(event[i]);
				this.arShadow.push(event[i]);
			}
		}

		this.dataSource = new MatTableDataSource(this.agencyResponses);

	}
	public onSubmitClicked(finalizeFlag: boolean): void {

		let message = '';
		let useDialog = false;

		this.closeRequest = finalizeFlag;

		if (!this.validateFields()) {
			return;
		}

		if ((this.approveAmount + this.alreadyProvided) > this.requested) {
			message = 'The amount you are providing is greater than the amount requested/remaining - Are You Sure' +
				' you want to continue?';
			useDialog = true;
		}
		else if (((this.approveAmount + this.alreadyProvided) < this.requested) && (this.closeRequest === true)) {
			message = 'WARNING: You are about to close this request for ALL agencies - Are You Sure?';
			useDialog = true;
		}

		if (useDialog === true) {
			const dialogData = new ConfirmDialogModel('Please Confirm', message);

			const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				width: '400px',
				data: dialogData,
				panelClass: 'custom-dialog-container'
			});

			dialogRef.afterClosed().subscribe(dialogResult => {
				this.result = dialogResult;
				if (this.result === false) {
					return;
				} else {
					// just continue execution
					this.proceedWithSubmitApproval();
				}
			});
		} else {
			this.proceedWithSubmitApproval();
		}
	}
	public onRowClicked(row: any): void {

		if (row === null) {
			return;
		}

		if ((this.primaryAgencyFlag === false) && (row.agencyId !== this.myAgencyId)) {
			return;
		}

		this.selectedRecord = row;
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);

		DwUtils.highlightFocus('idAmount');
	}
	public proceedWithSubmitApproval() {

		this.pendingStatusSnapshot = {
			requestStatusId: this.serviceRequest.requestStatusId,
			recordStatus: this.serviceRequest.recordStatus,
			statusReasonId: this.serviceRequest.statusReasonId
		};

		if (this.closeRequest === true) {
			this.serviceRequest.recordStatus = 0;
			this.serviceRequest.requestStatusId = 3;
			this.serviceRequest.requestStatusDesc = 'Approved';
			this.serviceRequest.keepOpen = 0;

			if (this.serviceRequest.clericalOpen === 1) {
				this.openRecloseDialog();
				// note: this.continueSubmitProcess is called from the Submit event
				// from the reclose dialog.
				this.reclosedlg.showRequestRecloseHandler(this.serviceRequest);

			} else {
				this.continueSubmitProcess(null);
			}
		} else {
			this.serviceRequest.recordStatus = 1;
			this.continueSubmitProcess(null);
		}
	}

	public continueSubmitProcess(payload: any) {

		const dateSnapshot = payload ? {
			dateCreated: this.serviceRequest.dateCreated,
			dateCompleted: this.serviceRequest.dateCompleted
		} : null;

		if (payload) {
			this.serviceRequest.newDateCompleted = payload.dateClosed;
			this.serviceRequest.newDateSubmitted = payload.dateSubmitted;
			this.serviceRequest.suppressEmailFlag = payload.supressEmails;
		}
		/** send the arShadow array to the service to persist or delete records **/
		this.globalService.openDialog();
		this.serviceRequestsService.manageAgencyResponses(this.arShadow).subscribe(
			(results) => {

				/** update the service request **/
				this.serviceRequest.totalAmountProvided = this.alreadyProvided;

				this.serviceRequestsService.updateRequests(this.serviceRequest, true).subscribe(
					(result1) => {
						this.globalService.closeDialog();
						this.serviceRequest.dateCompleted = result1['dateCompleted'];
						this.serviceRequest.dateCreated = result1['dateCreated'];
						this.serviceRequest.clericalOpen = result1['clericalOpen'];
						this.serviceRequest.recordStatus = result1['recordStatus'];
						this.serviceRequest.requestStatusId = result1['requestStatusId'];
						this.serviceRequest.statusReasonId = result1['statusReasonId'];

						if (this.pendingStatusSnapshot) {
							this.txService.logServiceRequestStatusChanges(this.serviceRequest.id, this.pendingStatusSnapshot, {
								requestStatusId: result1['requestStatusId'],
								recordStatus: result1['recordStatus'],
								statusReasonId: result1['statusReasonId']
							});
							if (this.closeRequest === true) {
								this.txService.createTransactionHistory('ServiceRequests', this.serviceRequest.id, 'Update',
									'Change Status: Approved');
							}
							this.pendingStatusSnapshot = null;
						}

						if (dateSnapshot) {
							this.txService.logServiceRequestDateChanges(this.serviceRequest.id, dateSnapshot, {
								dateCreated: result1['dateCreated'],
								dateCompleted: result1['dateCompleted']
							});
						}

						this.submitClicked.emit(this.serviceRequest);
					},
					(error) => {
						this.globalService.closeDialog()
						Settings.getInstance().handleError(error, 'updating the service request')
					});
			},
			(error) => {
				this.globalService.closeDialog()
				Settings.getInstance().handleError(error, 'managing agency responses');
			});

	}
	public onCancelClicked(): void {
		this.agencyResponses = [];
		this.cancelClicked.emit();
	}
	public validateFields(): boolean {

		this.strErr = '';
		
		if(this.requestemebrsMappins && this.requestemebrsMappins.length===0){
			this.strErr = 'Error: No member associated with this request';
				return false;
		}

		/** if we are ready to close the approval request, make sure that we don't have
		 * any non-committed statuses against the approvals **/


		if (this.closeRequest === true) {

			if (this.alreadyProvided === 0) {
				this.strErr = 'Error: Cannot finalize this approval: no amounts have been specified';
				return false;
			}

			for (const rec of this.dataSource.data) {

				if (rec.plannedCommitted !== 'Committed') {
					this.strErr = 'Error: All contributions must have a Commitment Status of \'Committed\' before' +
						' finalizing';
					return false;
				}
			}
		}
		else {
			for (const rec of this.dataSource.data) {
				if ((rec.plannedCommitted === 'Committed') && (Number(rec.amountProvided) <= 0)) {
					this.strErr = 'Error: A \'Committed\' record cannot have a zero amount - please add an amount' +
						' or remove the record ';
					return false;
				}
			}
		}
		return true;
	}
	/*** colors ***/
	public showCommitmentColors(statusVal: string): string {

		if (statusVal === undefined) {
			return '';
		}

		switch (statusVal) {
			case 'Requested':
				return 'orange';
			case 'Planned':
				return 'blue';
			case 'Committed':
				return 'green';

		}
		return '';
	}
	public openRecloseDialog() {
		this.displayRecloseDlg = true;
	}
	public submitFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
		this.continueSubmitProcess(event);
	}
	public cancelFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
	}
}
